export const frequentlyQuestion = [
  {
    question: "Không có bằng xe máy có học bằng lái xe ô tô không?",
    answers: [
      `Theo quy định của nhà nước, Bằng lái xe ô tô và bằng lái
    xe máy là hai hạng bằng khác nhau. Do đó người không có
    bằng lái xe máy vẫn được phép học bằng lái xe ô tô.`,
    ],
  },
  {
    question: "Trung tâm có hỗ trợ học lái xe ô tô bao đậu hay không?",
    answers: [
      `Học lái xe ô tô bao đậu hiện nay là điều không thể.\n
    Vì quá trình học và thi sát hạch của bạn đều chịu sự
    quản lý và giám sát trực tiếp bằng camera của bộ GTVT.`,
    ],
  },
  {
    question: "Thi bằng lái xe ô tô có khó không?",
    answers: [
      `Việc thi bằng lái xe ô tô sẽ vô cùng đơn giản nếu bạn đã
    trải qua quá trình học tập và thực hành lái xe tại Trung
    Tâm Đào Tạo Lái Xe PN.\n
    Các giáo viên tại trung tâm của chúng tôi sẽ hướng dẫn
    cho mọi người cách ôn tập lý thuyết và thực hành nhanh
    nhất.`,
    ],
  },
  {
    question: "Hồ sơ học lái xe ô tô có phức tạp hay không?",
    answers: [
      `Hồ sơ học bằng lái xe ô tô sẽ không hề phức tạp như bạn
    nghĩ. Sau khi bạn được tư vấn và hướng dẫn tại trung
    tâm, bạn sẽ chỉ phải mất 1-2 ngày cho quá trình chuẩn bị
    hồ sơ.`,
    ],
  },
  {
    question: "Bằng lái xe B11 và B2 khác nhau như thế nào?",
    answers: [
      `-B1: là GPLX cấp cho người điều khiển
    lái xe số tự động từ 4 đến 9 chỗ và không được phép tham
    gia kinh doanh. Đối tượng thích hợp để học xe số tự động
    là phụ nữ, người lớn tuổi về hưu\n`,
      `-B2: là GPLX cấp cho người điều khiển
  lái xe số sàn từ 4 đến 9 chỗ và được phép tham gia kinh
  doanh. Đối tượng thích hợp để học lái xe B2 là những
  người có nhu cầu kinh doanh, những bạn thanh niên cá
  tính.`,
    ],
  },
  {
    question: "Hồ sơ đăng ký học lái xe gồm những gì?",
    answers: [
      `-12 tấm ảnh 3x4 phông nền xanh`,
      `-1 CMND hoặc CCCD photo (có thể dùng Passport)`,
      `-1 Bằng lái xe máy PET photo (nếu có)`,
      `-Đơn xin học GPLX`,
      `-1 Giấy khám sức khỏe theo chuẩn mẫu học lái xe`,
    ],
  },
];
